import { TradingType } from '@/constants';
import { createSimpleDictionary } from '@/stores/utils/createSimpleDictionary';

export const tradingTypeDictionary = createSimpleDictionary([
    { id: TradingType.Bot, name: 'dictionaries.tradingType.bot' },
    { id: TradingType.BetOrder, name: 'dictionaries.tradingType.betOrder' },
]);
